export default __webpack_public_path__ + "static/media/kwid-gallery-6.5c61762d.jpg";